export default "__VITE_ASSET__2ccd52b5__"